import {resources, scopes} from '../../../permissions/dictionary';
import {paths} from '../../../dictionaries/urls';

export const KPI = [{
  'name': 'Ventas',
  'path': paths.SalesKpi,
  'resource': resources.SalesKpi,
  'scopes': [scopes.See],
  'icon': 'partSales',
}, {
  'name': 'Ventas de Combos',
  'path': paths.SetSales,
  'resource': resources.SetSales,
  'scopes': [scopes.See],
  'icon': 'comboSales',
}, {
  'name': 'Ventas de Repuestos',
  'path': paths.PartsSalesList,
  'resource': resources.PartsSalesReport,
  'scopes': [scopes.See],
  'icon': 'partsSales',
}, {
  'name': 'Líneas Recepcionadas y Despachadas',
  'path': paths.ReceivedAndDispatchedLinesKpi,
  'resource': resources.ReceivedAndDispatchedLinesKpi,
  'scopes': [scopes.See],
  'icon': 'barChart',
}, {
  'name': 'Uso de ubicaciones',
  'path': paths.LocationsUsageReport,
  'resource': resources.LocationsUsage,
  'scopes': [scopes.See],
  'icon': 'locationsUsage',
}, {
  'name': 'S/M by Icc',
  'path': paths.SmByicc,
  'resource': resources.SmByicc,
  'scopes': [scopes.See],
  'icon': 'partSales',
}];

export const QueryMenuItems = [
  {
    'name': 'Listado de Facturas',
    'path': paths.InvoicesList,
    'resource': resources.InvoicesList,
    'scopes': [scopes.See],
    'icon': 'invoicesDocuments',
  },
  {
    'name': 'Facturación Electrónica',
    'path': paths.FileInvoices,
    'resource': resources.FileInvoices,
    'scopes': [scopes.See],
    'icon': 'invoicesDocuments',
  },
  {
    'name': 'Búsqueda de combos',
    'path': paths.SearchCombosVehicles,
    'resource': resources.SearchCombosVehicles,
    'scopes': [scopes.See],
    'icon': 'searchCombos',
  },
  {
    'name': 'Reporte de Bo',
    'path': paths.BoReport,
    'resource': resources.BoReport,
    'scopes': [scopes.See],
    'icon': 'partSales',
  },
  {
    'name': 'Tasa de Servicio',
    'path': paths.ServiceReportPart,
    'resource': resources.ServiceReportPart,
    'scopes': [scopes.See],
    'icon': 'partSales',
  },
  {
    'name': 'Reporte Combos',
    'path': paths.ReportCombos,
    'resource': resources.ReportCombos,
    'scopes': [scopes.See],
    'icon': 'combosReport',
  },
  {
    'name': 'Reporte Ventas Japón',
    'path': paths.ReportPartsSalesJapan,
    'resource': resources.PartsSalesJapan,
    'scopes': [scopes.See],
    'icon': 'combosReport',
  },
  {
    'name': 'Dashboard de Ubicaciones de Repuestos',
    'path': paths.PartsLocationDashboard,
    'resource': resources.PartsLocationDashboard,
    'scopes': [scopes.See],
    'icon': 'combosReport',
  },
];

